import { takeLatest } from 'redux-saga/effects';
import { customersSliceActions as actions } from '.';
import { createRequestSaga } from '../../../../utils/saga';

const loadCustomers = createRequestSaga({
  actionType: actions.loadCustomersRequest.type,
  successAction: actions.loadCustomersSuccess,
  failureAction: actions.loadCustomersFailed,
  url: `customers`,
  data: p => ({ ...p }),
});

const loadCustomer = createRequestSaga({
  actionType: actions.loadCustomerRequest.type,
  successAction: actions.loadCustomerSuccess,
  failureAction: actions.loadCustomerFailed,
  url: p => `customers/${p.id}`,
});

const saveCustomer = createRequestSaga({
  actionType: actions.saveCustomerRequest.type,
  successAction: actions.saveCustomerSuccess,
  failureAction: actions.saveCustomerFailed,
  url: p => (p.id ? `customers/${p.id}` : 'customers'),
  method: p => (p.id ? 'put' : 'post'),
  data: p => ({ ...p }),
});

const deleteCustomer = createRequestSaga({
  actionType: actions.deleteCustomerRequest.type,
  url: p => `customers/${p.id}`,
  method: 'delete',
  successAction: actions.deleteCustomerSuccess,
  failureAction: actions.deleteCustomerFailed,
});

export function* customersSliceSaga() {
  yield takeLatest(actions.loadCustomersRequest.type, loadCustomers);
  yield takeLatest(actions.loadCustomerRequest.type, loadCustomer);
  yield takeLatest(actions.saveCustomerRequest.type, saveCustomer);
  yield takeLatest(actions.deleteCustomerRequest.type, deleteCustomer);
}
